import './Statistics.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import StatisticsCard from '../atoms/StatisticsCard/StatisticsCard';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get } from '../../utils';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var TABLET_BREAKPOINT = {
  max: 767,
  min: 0
};
var TABLE_PORTRAIT_BREAKPOINT = {
  max: 1282,
  min: TABLET_BREAKPOINT.max + 1
};
var DESKTOP_BREAKPOINT = {
  max: 1482,
  min: TABLE_PORTRAIT_BREAKPOINT.max + 1
};
var EXTRA_BREAKPOINT = {
  max: 10000,
  min: DESKTOP_BREAKPOINT.max + 1
};
var Statistics = function Statistics(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var items = get(props.fields, "data.item.children", []);
  var heading = get(props.fields, "data.item.heading.jss");
  var getClass = function getClass(type) {
    return "statistics__".concat(type, "--").concat(items.length, "-columns");
  };
  var eventsAnalytics = get(props.fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: props.params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "statistics module-group"
  }, items.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, heading && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: "statistics__title",
    field: heading
  }), items.length < 5 && /*#__PURE__*/React.createElement("div", {
    className: "statistics__list ".concat(getClass("list"))
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(StatisticsCard, {
      key: index,
      value: item.statNumber.jss,
      title: item.statTitle.jss,
      description: item.description.jss,
      compactHeader: items.length === 2
    });
  })), items.length > 2 && /*#__PURE__*/React.createElement("div", {
    className: "statistics__carousel ".concat(getClass("carousel"))
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref) {
    var renderDots = _ref.renderDots,
      renderCarousel = _ref.renderCarousel,
      renderNextButton = _ref.renderNextButton,
      renderPreviousButton = _ref.renderPreviousButton;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "statistics__btn-wrapper"
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNextPrevious"], props.params), "previous");
    }), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNextPrevious"], props.params), "next");
    })), renderCarousel(items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(StatisticsCard, {
        key: index,
        value: item.statNumber.jss,
        title: item.statTitle.jss,
        description: item.description.jss,
        compactHeader: items.length === 2
      });
    }), {
      responsive: {
        extra: {
          breakpoint: EXTRA_BREAKPOINT,
          items: items.length > 4 ? 4 : items.length
        },
        desktop: {
          breakpoint: DESKTOP_BREAKPOINT,
          items: items.length > 3 ? 3 : items.length
        },
        table_portrait: {
          breakpoint: TABLE_PORTRAIT_BREAKPOINT,
          items: items.length > 2 ? 2 : items.length
        },
        tablet: {
          breakpoint: TABLET_BREAKPOINT,
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "module-group no-padding-bottom"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNavigatorBubbles"], props.params));
    }))));
  })))));
};
export default Statistics;
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
var commonStyles = "c1hcuglw";
var rtlStyles = "r1835klt";
var ltrStyles = "log5xkm";